import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LangProvider } from './i18n';
import Header from './components/Header';
import Hero from './components/Hero';
import LeadForm from './components/LeadForm';
import TrustBar from './components/TrustBar';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Gallery from './components/Gallery';
import Brands from './components/Brands';
import Testimonials from './components/Testimonials';
import MilitaryBand from './components/MilitaryBand';
import SocialSection from './components/SocialSection';
import Location from './components/Location';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import MobileStickyCallBar from './components/MobileStickyCallBar';
import ThankYou from './components/ThankYou';

function Home() {
  return (
    <div className="page-wrapper">
      <Header />
      <main>
        <Hero />
        <LeadForm />
        <TrustBar />
        <Services />
        <WhyUs />
        <Gallery />
        <Brands />
        <Testimonials />
        <SocialSection />
        <MilitaryBand />
        <Location />
        <FinalCTA />
      </main>
      <Footer />
      <MobileStickyCallBar />
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
